import { MutationKey } from '@tanstack/react-query';

const baseKey: MutationKey = ['goCardless'];

export const goCardlessMutationKeys = {
  baseKey,
  connect: [...baseKey, 'connect'],
  disconnect: [...baseKey, 'disconnect'],
};
